//*********************************
// Image Lazy Load
//*********************************

let lazy = {}

lazy.load = function ( load ) {
    for (var i = 0; i < lazy.images.length; i++) {
        var self = lazy.images[i],
            src = self.getAttribute('data-src'),
            top = self.getBoundingClientRect().top,
            position = findPosition(),
            inWindow = load ? top > position && top < (position + window.innerHeight) : false;
        if( inWindow || !load ) {
            if( !self.classList.contains('loaded') && src.length > 0 ) {
                self.tagName == 'IMG' ? self.setAttribute('src', src) : self.style.backgroundImage = 'url('+src+')';
                self.classList.add('loaded');
            }
        }
    }
}

lazy.init = function ( selector, delay ) {
    selector = selector || '[data-src]';
    delay = delay || 5000;
    lazy.images = typeof selector === 'string' || selector instanceof String ? document.querySelectorAll(selector) : selector;
    lazy.timeout = setTimeout(function() {
        lazy.images.length > 0 ? lazy.load(false) : false;
	}, delay);
    lazy.checkforUserScroll = function() {
		console.log('scroll');
		window.removeEventListener('scroll', lazy.checkforUserScroll);
		clearTimeout(lazy.timeout);
		lazy.load(false);
	};
    lazy.load(true);
    //if the user scrolls, initiate loading the rest of the images
    window.addEventListener('scroll', lazy.checkforUserScroll, {passive : true});
}

module.exports.lazy = lazy;